import * as React from 'react';
import { CnCard as PCCnCard, CnCardSubCard as PCCnCardSubCard, } from '@cainiaofe/cn-ui';
export var CnCard = function (props) {
    var title = props.title, desc = props.desc, action = props.action, children = props.children, subTitle = props.subTitle, subDesc = props.subDesc, subAction = props.subAction, style = props.style, shape = props.shape, titleTips = props.titleTips, icon = props.icon;
    var displayChildren = children;
    if (subTitle) {
        displayChildren = (React.createElement(PCCnCardSubCard, { style: style, subTitle: subTitle, subDesc: subDesc, action: subAction }, displayChildren));
    }
    // 无 shape 走原来的映射逻辑
    var pcTitleTips = shape ? titleTips : desc;
    var pcDesc = shape ? desc : undefined;
    var pcIcon = shape ? icon : undefined;
    // 兼容历史逻辑，老版本card没有shape属性
    var noPadding = shape ? props.noPadding : undefined;
    return (React.createElement(PCCnCard, { style: style, title: title, icon: pcIcon, desc: pcDesc, titleTips: pcTitleTips, action: action, shape: shape, noPadding: noPadding }, displayChildren));
};
